<template>
  <div>
    <Branding>
      <Error />
    </Branding>
  </div>
</template>

<script>
// @ is an alias to /src
import Branding from "@/components/Branding.vue";
import Error from "@/components/Error.vue";

export default {
  name: "ErrorPage",
  components: {
    Branding,
    Error,
  },
};
</script>
